export default "__VITE_ASSET__YBFLP2j7__"